"use strict";

class InformacionPCDController {
  constructor(
    $uibModalInstance,
    data,
    $log,
    DataService,
    Message,
    $state,
    $scope,
    $http,
    apiUrl,
    Loading,
    helpLang,
    Storage
  ) {
    "ngInject";
    this.persona = data;
    this.$uibModalInstance = $uibModalInstance;
    this.$log = $log;
    this.DataService = DataService;
    this.Message = Message;
    this.$state = $state;
    this.$scope = $scope;
    this.apiUrl = apiUrl;
    this.$http = $http;
    this.Loading = Loading;
    this.helpLang = helpLang;
    this.Storage = Storage;
    this.validaciones = [];
    this.validacion = false;
  }

  $onInit() {
    this.validacion = false;
    this.codigoBeneficiario = '';
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  editarCodigoBeneficiario(form) {
    if (form.$valid) {
      this.DataService.put(`centralizador/soporte/actualizar-pcd/${this.persona.nro_documento}`,
      { codBeneficiario: this.codigoBeneficiario })
        .then(response => {
          if (response) {
            this.Message.success('El registro se ha actualizado con éxito.')
            this.items.refresh;
            this.$state.reload();
            this.$uibModalInstance.close();
          }
        })
        .catch((error) => {
          this.datosPcd = {};
          this.cancel();
          this.msgError(error);
        });
    }
  }

}

export default InformacionPCDController;



// WEBPACK FOOTER //
// ./src/app/components/soporte/casosPCD/casosPCDCorregirCodigo.controller.js